import {
  REGIONAL_EDUCATION_MEETING_REQUEST,
  US_EDUCATION_MATERIAL_HANDS_ON_REQUEST_FORM
} from 'Helpers/constant';
import { t } from 'i18next';
import * as Yup from 'yup';

export const approverSchema = (formTypeList = []) => {
  const formNameMap = Object.fromEntries(formTypeList?.map((form) => [form.id, form.formType]));

  return Yup.object().shape({
    form_id: Yup.string().required(`${t('approverManagement.errors.formRequired')}`),

    field: Yup.string().when('form_id', {
      is: (value) => formNameMap[value] === US_EDUCATION_MATERIAL_HANDS_ON_REQUEST_FORM,
      then: () => Yup.string().required(`${t('approverManagement.errors.fieldRequired')}`),
      otherwise: () => Yup.string().nullable()
    }),

    field_university_request: Yup.string().when('field', {
      is: 'HCP Proctor/University Faculty',
      then: () => Yup.string().required(`${t('approverManagement.errors.educationTypeRequired')}`),
      otherwise: () => Yup.string().nullable()
    }),

    regions: Yup.array().when('form_id', {
      is: (value) => formNameMap[value] === REGIONAL_EDUCATION_MEETING_REQUEST,
      then: () =>
        Yup.array()
          .min(1, `${t('approverManagement.errors.regionRequired')}`)
          .required(`${t('approverManagement.errors.regionRequired')}`),
      otherwise: () => Yup.array().nullable()
    }),

    approverName: Yup.string().required(`${t('approverManagement.errors.approverNameRequired')}`),

    approverEmail: Yup.string()
      .email(`${t('form.invalidEmail')}`)
      .required(`${t('approverManagement.errors.approverEmailRequired')}`),

    secondApproverName: Yup.string().when('secondApprover', {
      is: true,
      then: () =>
        Yup.string().required(`${t('approverManagement.errors.secondApproverNameRequired')}`),
      otherwise: () => Yup.string().nullable()
    }),

    secondApproverEmailAddress: Yup.string().when('secondApprover', {
      is: true,
      then: () =>
        Yup.string()
          .email(`${t('form.invalidEmail')}`)
          .required(`${t('approverManagement.errors.secondApproverEmailRequired')}`),
      otherwise: () => Yup.string().nullable()
    }),

    thirdApproverName: Yup.string().when('thirdApprover', {
      is: true,
      then: () =>
        Yup.string().required(`${t('approverManagement.errors.thirdApproverNameRequired')}`),
      otherwise: () => Yup.string().nullable()
    }),

    thirdApproverEmailAddress: Yup.string().when('thirdApprover', {
      is: true,
      then: () =>
        Yup.string()
          .email(`${t('form.invalidEmail')}`)
          .required(`${t('approverManagement.errors.thirdApproverEmailRequired')}`),
      otherwise: () => Yup.string().nullable()
    })
  });
};
